import {css, html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent'
import BaseService from '../../../BaseService'
import VNBService from '../../Verteilnetzbetreiber/VNBService'
import {List} from '@isceco/widget-library2/basic-elements/List/List'
import VerordnungMonitoringDto from '../VerordnungMonitoringDto'
import VerbrauchMonitoringPeriodeDTO from './VerbrauchMonitoringPeriodeDTO'
import '../../../components/Chart/TimeChart'
import '@isceco/widget-library2/basic-elements/Spinner/Spinner'
import '@isceco/widget-library2/basic-elements/Switch/Switch'
import VerordnungMonitoringService from '../VerordnungMonitoringService'

export default class VerbrauchMonitoring extends WebComponent {

  static get properties() {
    return {
      verordnung: {type: VerordnungMonitoringDto}
    }
  }

  constructor() {
    super()
    this.monitoringService = new VerordnungMonitoringService()
    this.queryParams = {}
  }

  get translationFile() {
    return './views/VerordnungMonitoring/Verbrauch/i18n.json'
  }

  get css() {
    return css`
      .hidden {
        display: none;
      }

      .filter-section {
        width: 100%;
        display: flex;
        flex-flow: wrap;
        align-items: center;
      }

      .button-with-spinner {
        display: flex;
        flex-direction: row;
        gap: 1em;
        align-items: center;
      }
    `
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener(List.EVENT_KEYS.RELOAD_TRIGGERED, this._filterChangedListener)
    this.reload()
  }


  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(List.EVENT_KEYS.RELOAD_TRIGGERED, this._filterChangedListener)
  }

  reload() {
    const vnbService = new VNBService()
    Promise.all([
      new BaseService('kanton').list(),
      vnbService.list('keyvalue'),
      new BaseService('plz').list(),
      new BaseService('ausnahmegruppe').list(),
      new BaseService('referenzjahren').list()
    ]).then(([kanton, vnb, plz, ausnahmegruppe, referenzperiode]) => {
      this.kantonList = kanton.map(k => ({value: k, name: k}))
      this.plzList = plz.map(p => ({value: p, name: p}))
      this.vnbList = vnb.map(v => ({value: v.key, name: v.value}))
      this.ausnahmegruppeList = ausnahmegruppe.filter(a => a !== 'KEINE').map(a => ({value: a, name: a}))
      this.referenzperiodeList = referenzperiode.map(r => ({value: r, name: r.toString()}))
    }).catch(() => {
      this.kantonList = []
      this.plzList = []
      this.vnbList = []
      this.ausnahmegruppeList = []
      this.referenzperiodeList = []
    }).finally(() => {
      this.render()
    })
  }

  getTemplate() {
    return html`
      <isceco-title text="${this.i18n.translate('tab.filterkriterien.title')}"
                    size="small"
      ></isceco-title>
      <div class="filter-section">
        <isceco-multiselect-filter key="kanton"
                                   label="${this.i18n.translate('filter.kanton.label')}"
                                   .items="${this.kantonList}"
        ></isceco-multiselect-filter>
        <isceco-multiselect-filter key="vnb"
                                   label="${this.i18n.translate('filter.vnb.label')}"
                                   .items="${this.vnbList}"
        ></isceco-multiselect-filter>
        <isceco-multiselect-filter key="plz"
                                   label="${this.i18n.translate('filter.plz.label')}"
                                   .items="${this.plzList}"
        ></isceco-multiselect-filter>
      </div>

      <isceco-title text="${this.i18n.translate('tab.ausnahmegruppe.title')}"
                    size="small"
      ></isceco-title>
      <p>${this.i18n.translate('tab.ausnahmegruppe.description')}</p>
      <div class="filter-section">
        <isceco-multiselect-filter key="ausnahmegruppe"
                                   label="${this.i18n.translate('filter.ausnahmegruppe.label')}"
                                   .items="${this.ausnahmegruppeList}"
        ></isceco-multiselect-filter>
      </div>

      <isceco-title text="${this.i18n.translate('tab.referenzperiode.title')}"
                    size="small"
      ></isceco-title>
      <p>${this.i18n.translate('tab.referenzperiode.description')}</p>
      <div class="filter-section" style="column-gap: .5em">
        <isceco-multiselect-filter key="referenzperiode"
                                   label="${this.i18n.translate('filter.referenzperiode.label')}"
                                   .items="${this.referenzperiodeList}"
        ></isceco-multiselect-filter>
        <isceco-switch key="referenzart"
                       label="${this.i18n.translate('filter.referenzart.label')}"
                       class="hidden"
        ></isceco-switch>
      </div>

      <br/>
      <div class="button-with-spinner">
        <isceco-button text="${this.i18n.translate('button.generieren')}"
                       variant="primary"
                       @click="${e => this._loadMonitoring(e)}"
        ></isceco-button>
        <isceco-spinner id="chart-spinner" hidden></isceco-spinner>
        <isceco-button text="${this.i18n.translate('button.reset')}"
                       variant="tertiary"
                       icon="filter icon"
                       style="align-self: end; margin-left: auto"
                       @click="${() => this._resetFilter()}"
        ></isceco-button>
      </div>

      <isceco-title text="${this.i18n.translate('tab.graphik.title')}"
                    size="small"
      ></isceco-title>
      ${this._renderChart()}
    `
  }

  _renderChart() {
    if (this.data) {
      const chartTitle = `${this.i18n.translate('tab.graphik.title.prefix')} ${this.verordnung.srNummer} (${formatDate(this.verordnung.geltungsdauerVon)} - ${formatDate(this.verordnung.geltungsdauerBis)})`
      return html`
        <eko-frontend-timechart id="monitoring-chart"
                                title="${chartTitle}"
                                .xAutoTicks="${(!this.data[0])}"
                                .data="${this.data}"
        ></eko-frontend-timechart>
      `
    } else {
      return html``
    }
  }

  _resetFilter = () => {
    this.queryParams = []
    this._getReferenzArt().classList.add('hidden')
    send(List.EVENT_KEYS.FILTER_CHANGED, {params: {}, identifier: this.identifier})
  }

  _loadMonitoring = event => {
    event.target.setAttribute('disabled', true) // deactivate button
    document.getElementById('chart-spinner').removeAttribute('hidden') // show spinner
    this.render()

    this.monitoringService.search(`${this.verordnung.id}/verbrauch`, this._getFilterParams())
      .then(json => {
        const perioden = json.map(p => new VerbrauchMonitoringPeriodeDTO(p))
        this.data = [
          this._parseKontingentChartLine(perioden),
          this._parseReferenzVerbrauchChartLine(perioden),
          this._parseVerbrauchsChartLine(perioden)
        ]
      })
      .catch(_ => {
        this.data = []
      })
      .finally(() => {
        event.target.removeAttribute('disabled') // reactivate button
        document.getElementById('chart-spinner').setAttribute('hidden', '') // hide spinner
        this.render()
      })
  }

  _getFilterParams = () => {
    const searchParams = new URLSearchParams('')
    Object.entries(this.queryParams).forEach(([key, value]) => {
      if (value instanceof Array) {
        value.forEach(multiValue => {
          searchParams.append(key, multiValue)
        })
      } else {
        if (!isEmpty(value)) {
          searchParams.append(key, value)
        } else if (value === null || value === undefined) {
          delete this.queryParams[key]
        }
      }
    })
    const referenzart = this._getReferenzArt()?.getValue() ?? false
    if (referenzart === true) {
      searchParams.append('referenzart', 'MEDIAN')
    }
    return searchParams.toString()
  }

  _parseVerbrauchsChartLine = perioden => {
    let dates = []
    let verbrauchs = []
    perioden.forEach(period => {
      dates = [...dates, ...period.verbrauchs.map(v => v.date)]
      verbrauchs = [...verbrauchs, ...period.verbrauchs.map(v => v.value * 1000)]
    })

    return {
      x: dates,
      y: verbrauchs,
      name: this.i18n.translate('graph.legend.verbrauch'),
      line: {
        shape: 'spline',
        width: 3,
        color: '#0d79de'
      }
    }
  }

  _parseReferenzVerbrauchChartLine = perioden => {
    let dates = []
    let referenzverbrauch = []
    perioden.forEach(period => {
      dates = [...dates, ...period.referenz.map(v => v.date)]
      referenzverbrauch = [...referenzverbrauch, ...period.referenz.map(v => v.value * 1000)]
    })

    return {
      x: dates,
      y: referenzverbrauch,
      name: this.i18n.translate('graph.legend.referenzverbrauch'),
      line: {
        shape: 'spline',
        width: 3,
        color: '#999999'
      }
    }
  }

  _parseKontingentChartLine = perioden => {
    // add virtual starting point
    const dates = [perioden[0].start, ...perioden.map(p => p.end)]
    const kontingenten = [(perioden[0].kontingent ?? 0) * 1000, ...perioden.map(p => p.kontingent * 1000)]
    return {
      x: dates,
      y: kontingenten,
      name: this.i18n.translate('graph.legend.kontingent'),
      marker: {
        // hide first marker
        size: [0, ...perioden.map(_ => 10)],
        symbol: 'diamond'
      },
      line: {
        shape: 'vh',
        width: 3,
        color: '#d32a0a'
      }
    }
  }

  // _filterChangedListener inspired from _triggerReload from List.js
  _filterChangedListener = event => {
    const {key, value, params} = event.detail
    if (params) {
      // If 'params' object is provided, set query parameters for each key-value pair
      for (const paramKey in params) {
        if (params.hasOwnProperty(paramKey)) {
          const paramValue = params[paramKey]
          this._handleQueryParam(paramKey, paramValue)
        }
      }
    } else {
      this._handleQueryParam(key, value)
    }
    if (key === 'referenzperiode') {
      if (value.length > 2) {
        this._getReferenzArt().classList.remove('hidden')
      } else {
        this._getReferenzArt().classList.add('hidden')
      }
      this.render()
    }
  }

// _handleQueryParam copy-pasted from List.js
  _handleQueryParam = (key, value) => {
    if (!isEmpty(value) && typeof value.from !== 'undefined') {
      this.queryParams[`${key}_from`] = value.from
      this.queryParams[`${key}_to`] = value.to
    } else if (value === null) {
      delete this.queryParams[key]
    } else {
      this.queryParams[key] = value
    }
  }

  _getReferenzArt() {
    return document.querySelector('isceco-switch[key=referenzart]')
  }

}
customElements.define('eko-frontend-kontingentierung-monitoring', VerbrauchMonitoring)
